import { DatePickerField, ExecuteButton, Form } from '@/components';
import { BulkCopyFormSchema } from '@/features/project/_models/group';
import { useForm } from '@/hooks';
import { isRS } from '@/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof BulkCopyFormSchema>;

type Props = {
  fiscalYear: number | undefined;
  onSubmit: (values: FormValues) => void;
  isLoading: boolean;
};

export const BulkCopyForm: FC<Props> = ({
  fiscalYear,
  onSubmit,
  isLoading,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      fiscalYear: fiscalYear ? dayjs().year(fiscalYear + 1) : undefined,
    },
    resolver: zodResolver(BulkCopyFormSchema),
  });
  return (
    <Form
      leavePageAlertCondition={null}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <DatePickerField
        picker="year"
        name="fiscalYear"
        label={t('bulk-copy-target-fiscal-year')}
        disabledDate={(current) => {
          if (!fiscalYear) {
            return false;
          }
          return current < dayjs().year(fiscalYear).endOf('year');
        }}
        control={control}
        errors={errors}
        disabled={isRS()}
      />

      <ExecuteButton loading={isLoading} />
    </Form>
  );
};
